<template lang="pug">
  div
    v-btn(color="secondary" @click="dialog = true") Назначить на

    v-dialog(v-model="dialog" width="700px")
      v-card(dark)
        v-card-title Переназначить вопрос
        v-card-text
          p Выберите специалиста на котороо хотите переназначить вопрос:
          v-select(
            v-model="selected"
            :items="users"
            item-value="id"
            item-text="username"
            label="Выберите специалиста"
          )
        v-card-actions
          v-btn(color="error" @click="dialog = false") Отмена
          v-spacer
          v-btn(color="success" @click="save" :disabled="!selected") Переназначить
</template>
<script>
import userService from '@/services/API/user';

export default {
  props: {
    users: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      dialog: false,
      selected: null,
    };
  },

  methods:{

    async save() {
      await userService.changeUser({ user_id: this.selected });
    },
  },

};
</script>
